
$('.cart-upsell__items').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots:false,
  // infinite:false,
});

$('.country-selector__stat').click(function(e){
    e.stopPropagation();
    $('.country-selector__items').toggleClass('show-selector');
});

$(document).click(function(){
    $('.country-selector__items').removeClass('show-selector');
});

// $('.country-selector__name').click(function(e){
//     e.stopPropagation();
//     $('.country-selector__items').toggleClass('show-selector');
// });


$('.blog-post__tab-item').click(function(e){
    e.preventDefault();
    var blog_link = $(this).attr('data-blog');

    fetch(blog_link+"/?section_id=blog-posts-new")
      .then((response) => response.text())
      .then((posts) => {
        var tagged_posts = $(posts);
        var post_items = $(".blog-post__items", tagged_posts);
        $(".blog-post__items").replaceWith(post_items);
      });
});

$('.custom-dropdown-item').click(function(e){
    e.preventDefault();
    var blog_link = $(this).attr('data-blog');

    fetch(blog_link+"/?section_id=blog-posts-new")
      .then((response) => response.text())
      .then((posts) => {
        var tagged_posts = $(posts);
        var post_items = $(".blog-post__items", tagged_posts);
        $(".blog-post__items").replaceWith(post_items);
      });
});

// $('.custom-dropdown-item').click(function(){
//     var blog_link = $(this).attr('data-blog');
//     window.location.href = blog_link;
//     })


    var page_url = window.location.href;
    var section_name = page_url.split('#');
    $('#'+section_name[1]).css('display', 'flex');
    console.log(section_name[1]);


    $('.read-more').click(function(){
      $('.product-single__description.mobi').addClass('show-less');
    });
    $('.read-less').click(function(){
      $('.product-single__description.mobi').removeClass('show-less');
    });


    $('.mob-drop').click(function(e){
      e.preventDefault();
      $(this).next().slideToggle();
      $(this).toggleClass('drop-menu-opened');
    });

    
